module.exports = __webpack_public_path__ + "img/canbadge_round_100mm_trimmark.89b78958.png";